import { createAsyncThunk } from '@reduxjs/toolkit';

import materialTypesApi from '~/apis/material-type';
import { CREATE_MATERIAL_TYPE } from '~/utils/constants/actionType';

import { IMaterialType } from '~/utils/interface/material-type';

export const handleCreateMaterialTypes = createAsyncThunk<IMaterialType, IMaterialType>(
  CREATE_MATERIAL_TYPE,
  async (data: IMaterialType, { rejectWithValue }) => {
    try {
      const res = await materialTypesApi.create(data);

      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
